import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import Disciplines from '../../../api/models/discipline';
import { getDisciplines } from '../../../api/services/disciplineService';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';

type ViewState = {
  message?: string;
};

const ViewDisciplines = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Discipline Name',
        accessor: 'name',
      },
      /*{
        Header: 'Discipline Group',
        accessor: 'disciplineGroupId',
      },*/
      {
        accessor: 'disciplineId',
        disableSortBy: true,
        Cell: () => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon className="w-5 h-5 cursor-pointer" aria-hidden="true" />
              </span>
            </div>
          );
        },
        width: 50,
        className: "hidden sm:table-cell"
      },
    ],
    []
  );

  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const [disciplines, setDisciplines] = useState<Disciplines[]>([]);

  const { error, isPending } = useAsync({
    promiseFn: getDisciplines,
    onResolve: (r) => {
      setDisciplines(r.data.disciplines);
    },
  });

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={isPending}>
      <Fragment>
        {state?.message && <Notification message={state?.message} />}
        <div className='mb-4 mt-4 text-right'>
          <Link className='btn' to='/admin/disciplines/groups'>
            Manage Groups
          </Link>
          <Link className='btn ml-4' to='/admin/disciplines/new'>
            Add Discipline
          </Link>
        </div>

        <DataTable
          columns={columns}
          data={disciplines}
          showPagination={true}
          getRowProps={(row: any) => ({
            onClick: () => history.push(`/admin/disciplines/${row.values.disciplineId}`),
            className: "cursor-pointer hover:bg-gray-100",
          })}
        />
      </Fragment>
    </Layout>
  );
};

export default ViewDisciplines;
